export default class StickyModal {
  constructor(el) {
    this.stickyModal = el;
    this.closeButton = this.stickyModal.querySelector('[data-js-sticky-modal-close]');
    this.delay = this.stickyModal.getAttribute('data-js-sticky-delay');
    this.stickyModalContentIds = this.stickyModal.querySelector('[data-js-sticky-modal-ids]');
    this.stickyModalcookieId = 'close--' + this.stickyModalContentIds.getAttribute('data-js-sticky-modal-ids');
    this.stickyModalcookie = this.getCookie(this.stickyModalcookieId);

    if (this.stickyModalcookie !== 'true') {
      setTimeout(this.showModal.bind(this), this.delay);
    }
  }

  showModal() {
    this.stickyModal.classList.remove('hidden-modal');
    this.closeButton.addEventListener('click', () => {
      this.closeModal();
    });
    this.stickyModal.addEventListener('click', (e) => {
      if(e.target !== e.currentTarget) return;
      this.closeModal();
    });
  }

  closeModal() {
    this.stickyModal.classList.add('hidden-modal');
    this.setCookie(this.stickyModalcookieId, 'true', 90);
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  static init(el) {
    return new this(el);
  }
}
